<template>
  <div>
    <!-- Navbar fixée en haut -->
    <b-navbar fixed="top" type="light" variant="light" class="px-2">
      <!-- Bouton Hamburger (menu principal) uniquement si connecté -->
      <button
          v-if="isLogged"
          class="btn btn-outline-secondary me-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#sidebar"
          aria-controls="sidebar"
        >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Titre centré -->
      <b-navbar-brand class="mx-auto" @click="handleLogoClick" style="cursor: pointer;">7Gsoft</b-navbar-brand>

      <!-- Cercle Profil => ouvre la modal Profil -->
      <button
          v-if="!isMaintenance"
          class="btn btn-outline-secondary profile-circle"
          type="button"
          @click="isProfileModalVisible = true"

        >👤</button>
    </b-navbar>

             <!-- Modal de profil -->
       <b-modal
           v-model="isProfileModalVisible"
           id="profileModal"
           :title="isLogged && userName ? userName : 'Profil'"
           hide-footer
           size="md"
         >
        <ul class="list-unstyled">
          <li v-if="!isLogged" class="mb-2">
            <b-button
                variant="primary"
                block
                @click="handleProfileLogin">
              Se connecter
            </b-button>
          </li>
          <template v-else>
            <!-- Section Notifications FCM (téléphone uniquement) -->
            <li v-if="isMobile" class="mb-3">
              <div class="notification-section">
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    id="fcmToggle"
                    v-model="fcmEnabled"
                    @change="toggleFCM"
                    :disabled="loading || !fcmSupported"
                  >
                  <label class="form-check-label" for="fcmToggle">
                    <small>Activer les notifications FCM</small>
                  </label>
                </div>

                <div v-if="fcmError" class="mt-1">
                  <small class="text-danger">
                    <i class="fas fa-exclamation-triangle"></i>
                    {{ fcmError }}
                  </small>
                </div>
              </div>
            </li>

            <li class="mb-2">
              <b-button variant="secondary" block @click="goToProfil">
                Profil
              </b-button>
            </li>
            <li class="mb-2">
              <b-button variant="info" block @click="goToVersions">
                📋 Historique des versions
              </b-button>
            </li>
            <li>
              <b-button variant="danger" block @click="logout">
                Déconnexion
              </b-button>
            </li>
          </template>
        </ul>
      </b-modal>

    <!-- Offcanvas Menu Principal (gauche) uniquement si connecté -->
    <div
        v-if="isLogged"
        class="offcanvas offcanvas-start"
        tabindex="-1"
        id="sidebar"
        aria-labelledby="sidebarLabel"
      >
      <div class="offcanvas-header">
        <h5 id="sidebarLabel">Menu</h5>
        <button
            type="button"
            class="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Fermer"
        ></button>
      </div>
      <!-- Boutons menu latérales -->
      <div class="offcanvas-body d-flex flex-column">
        <b-button
            variant="primary"
            block
            class="mb-2"
            @click="goToAccueil"
            data-bs-dismiss="offcanvas"
        >
          Accueil
        </b-button>
        <b-button
            variant="secondary"
            block
            class="mb-2"
            @click="goToHome"
            data-bs-dismiss="offcanvas"
        >
          Home
        </b-button>
        <b-button
            variant="secondary"
            block
            class="mb-2"
            @click="goToIntervention"
            data-bs-dismiss="offcanvas"
        >
          Interventions
        </b-button>
        <b-button
            variant="secondary"
            block
            class="mb-2"
            @click="goToTasks"
            data-bs-dismiss="offcanvas"
        >
          Tâches
        </b-button>
        <b-button
            variant="secondary"
            block
            class="mb-2"
            @click="goToPhoto"
            data-bs-dismiss="offcanvas"
        >
          Photo
        </b-button>
        <b-button
            variant="secondary"
            block
            class="mb-2"
            @click="goToLogs"
            data-bs-dismiss="offcanvas"
        >
          Logs Système
        </b-button>
        <b-button
            variant="secondary"
            block
            class="mb-2"
            @click="goToInterventionTime"
            data-bs-dismiss="offcanvas"
        >
          Temps d'Intervention
        </b-button>
      </div>
    </div>

    <!-- Modal de connexion -->
    <b-modal
        v-model="isModalVisible"
        id="loginModal"
        title="Connexion"
        @hide="resetLoginForm"
        hide-footer
    >
      <b-form @submit.prevent="handleLogin">
        <b-form-group label="Identifiant :" label-for="identifiant">
          <b-form-input id="identifiant"
                        v-model="identifiant"
                        required />
        </b-form-group>
        <b-form-group label="Mot de passe :" label-for="password">
          <b-form-input id="password"
                        type="password"
                        v-model="password"
                        required />
        </b-form-group>
        <div v-if="errorMessage" class="text-danger mb-3">
          {{ errorMessage }}
        </div>
        <b-button type="submit" variant="success" block>
          Se connecter
        </b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import api from "@/plugins/api.js";
import FCMService from '@/services/fcmService';

export default {
  name: "HeaderComponent",
  data() {
    return {
      isModalVisible: false,
      isProfileModalVisible: false,
      identifiant: "",
      password: "",
      errorMessage: "",
      isLogged: false,
      // Notifications FCM
      loading: false,
      fcmEnabled: false,
      fcmSupported: false,
      fcmError: null,
      fcmToken: null,
      devices: []
    };
  },
  async mounted() {
    await this.verifySession();
    // Assure l'en-tête Authorization par défaut après vérification
    const token = localStorage.getItem('access_token');
    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      console.debug('[FCM] Authorization header set from localStorage');
    }

    window.addEventListener("tokenRefreshed", this.onTokenRefreshed);
    window.addEventListener("fcmTokenRefreshed", this.onFCMTokenRefreshed);

    // Si connecté, précharger les devices pour refléter l'état du toggle
    if (this.isLogged) {
      try {
        await this.loadUserDevices();
        const rawUser = localStorage.getItem('user');
        const currentUser = rawUser ? JSON.parse(rawUser) : null;
        const currentUserId = currentUser?.id;
        const savedToken = FCMService.getToken() || localStorage.getItem('fcm_token');
        const deviceTokens = (this.devices || []).map(d => (d.fcm_token || '').slice(0, 12));
        const match = Array.isArray(this.devices) && savedToken
          ? this.devices.some(d => d.fcm_token === savedToken)
          : false;
        console.debug('[FCM][PreInit] userId:', currentUserId, 'devices:', this.devices?.length || 0, 'deviceTokens:', deviceTokens, 'savedToken:', (savedToken || '').slice(0, 12), 'match:', match);
        this.fcmEnabled = !!match;
      } catch (e) {
        console.debug('Préchargement des devices FCM échoué:', e);
      }
    }

    await this.initializeFCM();
  },
  beforeUnmount() {
    window.removeEventListener("tokenRefreshed", this.onTokenRefreshed);
    window.removeEventListener("fcmTokenRefreshed", this.onFCMTokenRefreshed);
  },

  computed: {
    isMaintenance() {
      return this.$route.name === "Maintenance";
    },
    
    isMobile() {
      const ua = navigator.userAgent || '';
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua));
    },

    userName() {
      if (!this.isLogged) return null;
      const user = localStorage.getItem('user');
      if (user) {
        try {
          const userData = JSON.parse(user);
          return userData.name || userData.username || 'Utilisateur';
        } catch (e) {
          return 'Utilisateur';
        }
      }
      return 'Utilisateur';
    }
  },

  watch: {
    '$route'(to) {
      if (to.name === 'Maintenance') {
        this.isProfileModalVisible = false;
      }
    }
  },

  methods: {

    openProfileModal() {
      // Si le site est en maintenance, on bloque l’ouverture
      if (this.isMaintenance) return;
      this.isProfileModalVisible = true;
    },

    onTokenRefreshed() {
        this.isLogged = true;
      },

    /**
     * Gérer le rafraîchissement du token FCM
     */
    async onFCMTokenRefreshed(event) {
      console.log('🔄 Token FCM rafraîchi, rechargement des devices...', event.detail);
      try {
        // Recharger les devices pour mettre à jour l'état
        await this.loadUserDevices();
        
        // Vérifier si le nouveau token est dans la liste
        const newToken = FCMService.getToken() || localStorage.getItem('fcm_token');
        const isRegistered = Array.isArray(this.devices) && newToken
          ? this.devices.some(d => d.fcm_token === newToken)
          : false;
        
        this.fcmEnabled = !!isRegistered;
        this.fcmToken = newToken;
        
        if (isRegistered) {
          this.fcmError = null;
          console.log('✅ Token FCM mis à jour et device toujours actif');
        }
      } catch (error) {
        console.error('Erreur lors du rechargement des devices après rafraîchissement du token:', error);
      }
    },

    async verifySession() {
      const token = localStorage.getItem("access_token");
      if (!token) {
        this.isLogged = false;
        return;
      }

      try {
        // on vérifie si l'access token est toujours valide
        await api.get("/auth/verify_session", {
          headers: { Authorization: `Bearer ${token}` },
        });
        // si ok, on passe isLogged à true
        this.isLogged = true;
      } catch (err) {
        // si 401, on tente le refresh
        if (err.response && err.response.status === 403) {
          const refresh = localStorage.getItem("refresh_token");
          if (refresh) {
            try {
              const { data } = await api.post("/auth/refresh", { refresh });
              localStorage.setItem("access_token", data.access);
              // on remet l'en-tête par défaut au cas où
              api.defaults.headers.common["Authorization"] = `Bearer ${data.access}`;
              // et on réessaie la vérification une dernière fois
              await this.verifySession();
              return;
            } catch {
              // refresh ko, on déconnecte
            }
          }
        }
        // pour tout autre cas ou si refresh échoue
        this.isLogged = false;
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
      }
    },

    openModal() {
      this.isModalVisible = true;
    },

    handleProfileLogin() {
        this.isProfileModalVisible = false;
        this.openModal();
      },

    async handleLogin() {
      this.errorMessage = "";
      try {
        const { data } = await api.post("/auth/login", {
          identifiant: this.identifiant,
          password: this.password,
        });
        localStorage.setItem("access_token", data.access);
        localStorage.setItem("refresh_token", data.refresh);
        localStorage.setItem("user", JSON.stringify(data.user));
        this.isModalVisible = false;
        this.verifySession();
        this.$router.push("/accueil");
      } catch (err) {
        if (err.isMaintenance) {
          this.$router.push("/maintenance");
          return;
        }
        this.errorMessage =
            err.response?.data?.detail ||
            err.response?.data?.error ||
            `Erreur ${err.response?.status}` ||
            err.message;
        setTimeout(() => { this.errorMessage = ""; }, 4000);
      }
    },
    resetLoginForm() {
      this.identifiant = "";
      this.password = "";
      this.errorMessage = "";
    },
    logout() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      this.isLogged = false;
      this.isProfileModalVisible = false;
      this.$router.push("/home");
    },

    goToAccueil() {
      this.$router.push("/accueil");
    },

    goToProfil() {
      this.isModalVisible = false;
      this.isProfileModalVisible = false;
      this.$router.push("/profile");
    },


    goToHome() {
      this.$router.push("/home");
    },


    goToIntervention() {
      this.$router.push("/interventions");
    },

    goToTasks() {
      this.$router.push("/tasks");
    },

    goToPhoto() {
      this.$router.push("/photos");
    },

    goToLogs() {
      this.$router.push("/logs");
    },

    goToInterventionTime() {
      this.$router.push("/intervention-time");
    },

    goToVersions() {
      this.isProfileModalVisible = false;
      this.$router.push("/versions");
    },

    handleLogoClick() {
      if (this.isLogged) {
        this.$router.push("/accueil");
      } else {
        this.$router.push("/home");
      }
    },

    // Méthodes pour les notifications FCM
    async initializeFCM() {
      try {
        // Vérifier le support
        this.fcmSupported = FCMService.isFCMSupported();
        
        if (this.fcmSupported) {
          // Initialiser le service FCM
          await FCMService.initialize();
          this.fcmToken = FCMService.getToken();
          
          // Vérifier si le device courant est déjà enregistré (par token exact)
          await this.loadUserDevices();
          const rawUser = localStorage.getItem('user');
          const currentUser = rawUser ? JSON.parse(rawUser) : null;
          const currentUserId = currentUser?.id;
          const currentToken = this.fcmToken || FCMService.getToken() || localStorage.getItem('fcm_token');
          const deviceTokens2 = (this.devices || []).map(d => (d.fcm_token || '').slice(0, 12));
          const isRegistered = Array.isArray(this.devices) && currentToken
            ? this.devices.some(d => d.fcm_token === currentToken)
            : false;
          console.debug('[FCM][PostInit] userId:', currentUserId, 'devices:', this.devices?.length || 0, 'deviceTokens:', deviceTokens2, 'currentToken:', (currentToken || '').slice(0, 12), 'isRegistered:', isRegistered);
          this.fcmEnabled = !!isRegistered;
          
          if (isRegistered) {
            this.fcmError = null;
          } else {
            this.fcmError = 'Device non enregistré';
          }
        } else {
          this.fcmError = 'FCM non supporté par ce navigateur';
        }
      } catch (error) {
        console.error('Erreur lors de l\'initialisation FCM:', error);
        this.fcmError = error.message || 'Erreur lors de l\'initialisation FCM';
      }
    },

    async toggleFCM() {
      this.loading = true;
      this.fcmError = '';

      try {
        if (this.fcmEnabled) {
          // Le toggle vient de passer à ON -> enregistrer le device
          console.log('Activation FCM...');
          await FCMService.registerDevice();
          this.fcmEnabled = true;
          this.fcmError = null;
          alert('✅ Notifications FCM activées !');
          // Recharger les devices
          await this.loadUserDevices();
        } else {
          // Le toggle vient de passer à OFF -> désinscrire le device
          console.log('Désactivation FCM...');
          await FCMService.unregisterDevice();
          this.fcmEnabled = false;
          alert('ℹ️ Notifications FCM désactivées');
        }
      } catch (error) {
        console.error('Erreur lors du toggle FCM:', error);
        this.fcmError = error.message || 'Erreur lors de la modification FCM';
        alert('❌ ' + this.fcmError);
        // En cas d'erreur, on remet le toggle dans l'état précédent
        this.fcmEnabled = !this.fcmEnabled;
      } finally {
        this.loading = false;
      }
    },

    async testFCM() {
      this.loading = true;
      try {
        console.log('Test FCM...');
        // Ici vous pourrez implémenter l'envoi d'une notification de test
        // via votre application externe
        alert('🔔 Test FCM - Vérifiez votre application externe');
      } catch (error) {
        console.error('Erreur lors du test FCM:', error);
        alert('❌ Erreur lors du test FCM: ' + (error.message || 'Erreur inconnue'));
      } finally {
        this.loading = false;
      }
    },

    async loadUserDevices() {
      try {
        const response = await FCMService.getUserDevices();
        this.devices = response.devices || [];
      } catch (error) {
        console.error('Erreur lors du chargement des devices:', error);
      }
    },

    checkFCMSupport() {
      const supportDetails = {
        serviceWorker: 'serviceWorker' in navigator,
        pushManager: 'PushManager' in window,
        notification: 'Notification' in window,
        permission: Notification.permission,
        fcmSupported: FCMService.isFCMSupported()
      };
      
      console.log('Détails du support FCM:', supportDetails);
      
      if (!this.fcmSupported) {
        alert('⚠️ Votre navigateur ne supporte pas FCM');
      } else {
        const permissionText = {
          'granted': 'Autorisées',
          'denied': 'Refusées',
          'default': 'Non définies'
        };
        
        alert(`✅ FCM Supporté: OK | Permission: ${permissionText[supportDetails.permission]}`);
      }
    }
  },
};
</script>

<style scoped>
/* espace sous navbar fixe */
body { padding-top: 56px; }

/* Sidebar : largeur responsive */
.offcanvas-start {
  width: 80vw !important;
}
@media (min-width: 1024px) {
  .offcanvas-start {
    width: 20vw !important;
  }
}
.offcanvas {
  transition: transform 0.6s ease-in-out;
}

/* Cercle Profil */
.profile-circle {
  width: 2.2rem;
  height: 2.2rem;
  background-color: #ddd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  cursor: pointer;
  user-select: none;
}
.profile-circle:hover {
  background-color: #ccc;
}

/* Styles pour la section notifications dans la modal */
.notification-section {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  margin-bottom: 0.5rem;
}

.notification-section h6 {
  color: #495057;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.form-check-input:checked {
  background-color: #28a745;
  border-color: #28a745;
}

.form-check-input:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.btn-sm {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

.text-success {
  color: #28a745 !important;
}

.text-danger {
  color: #dc3545 !important;
}
</style>
